<script setup lang="ts">
defineProps<{
  message: string;
}>();
</script>

<template>
  <Transition name="toast">
    <div v-if="message" class="toast" data-testid="toast">{{ message }}</div>
  </Transition>
</template>

<style scoped>
.toast {
  position: absolute;
  z-index: 30;
  top: 96px;
  left: 50%;
  transform: translateX(-50%);
  padding: 24px 48px;
  border-radius: 9999px;
  background: var(--entr-ink);
  color: var(--entr-text);
  font-size: 28px;
  white-space: nowrap;
}

.toast-enter-active,
.toast-leave-active {
  transition:
    opacity 180ms ease,
    transform 180ms ease;
}

.toast-enter-from,
.toast-leave-to {
  opacity: 0;
  transform: translateX(-50%) translateY(-12px);
}
</style>
